const ROUTE =
  "M 300 64 C 350 92, 352 106, 334 122 C 290 170, 226 200, 242 246 C 255 292, 304 310, 288 354 C 274 400, 204 420, 198 464 C 192 512, 282 514, 286 558 C 289 610, 168 606, 140 648";

const STOPS = [
  { town: "Canberra", chip: "Pickup hub", x: 300, y: 64, side: "end", hub: true },
  { town: "Queanbeyan", chip: "On the run", x: 334, y: 122, side: "end" },
  { town: "Michelago", chip: "On the run", x: 242, y: 246, side: "end" },
  { town: "Bredbo", chip: "On the run", x: 288, y: 354, side: "start" },
  { town: "Cooma", chip: "Same / next-day", x: 198, y: 464, side: "end" },
  { town: "Berridale", chip: "Same / next-day", x: 286, y: 558, side: "start" },
  { town: "Jindabyne", chip: "Snowfields gateway", x: 140, y: 648, side: "start" },
];

const SATELLITES = [
  { town: "Kalkite", x: 238, y: 522, side: "end" },
  { town: "East Jindabyne", x: 300, y: 640, side: "start" },
  { town: "Moonbah", x: 48, y: 650, side: "start" },
  { town: "Hilltop", x: 292, y: 692, side: "start" },
];

const CHIP_W = {
  "Pickup hub": 88,
  "On the run": 92,
  "Same / next-day": 122,
  "Snowfields gateway": 146,
};

const PINES = [
  [60, 180], [368, 230], [90, 330], [362, 420], [70, 545], [352, 475],
];

const Pine = ({ x, y }) => (
  <g transform={`translate(${x} ${y})`} opacity="0.55">
    <path d="M0 -14 L8 2 L3 2 L10 16 L-10 16 L-3 2 L-8 2 Z" fill="#1A3A2B" stroke="#1E9E5A" strokeWidth="0.8" strokeOpacity="0.5" />
  </g>
);

export default function RouteMap() {
  return (
    <div
      data-testid="route-map"
      className="relative overflow-hidden rounded-2xl border border-white/10 bg-[#122A1F]/70 p-4 sm:p-6"
    >
      <p className="font-mono-brand px-2 pb-3 text-[10px] uppercase tracking-[0.3em] text-[#F0A829]">
        The run — Monaro NSW + ACT
      </p>
      <svg viewBox="0 0 420 740" className="h-auto w-full" role="img" aria-label="Illustrated delivery route from Canberra through Queanbeyan, Michelago, Bredbo, Cooma and Berridale to Jindabyne">
        {/* mountains */}
        <g opacity="0.9">
          <path d="M12 740 L72 676 L132 740 Z" fill="#132E21" />
          <path d="M58 696 L72 676 L86 696 L79 691 L72 697 L65 691 Z" fill="#F6F1E3" opacity="0.85" />
          <path d="M150 740 L230 660 L310 740 Z" fill="#0F271C" />
          <path d="M215 682 L230 660 L245 682 L237 677 L230 683 L222 677 Z" fill="#F6F1E3" opacity="0.7" />
          <path d="M320 740 L375 672 L420 740 Z" fill="#132E21" />
          <path d="M363 688 L375 672 L387 688 L381 683 L375 689 L369 683 Z" fill="#F6F1E3" opacity="0.8" />
        </g>

        {PINES.map(([x, y]) => (
          <Pine key={`${x}-${y}`} x={x} y={y} />
        ))}

        {/* compass */}
        <g transform="translate(382 46)">
          <circle r="15" fill="none" stroke="#F0A829" strokeOpacity="0.5" strokeWidth="1.2" />
          <path d="M0 -9 L4 5 L0 2 L-4 5 Z" fill="#F0A829" />
          <text y="-20" textAnchor="middle" fill="#F0A829" fontSize="10" fontFamily="JetBrains Mono, monospace">N</text>
        </g>

        {/* route underlay + animated dashed line */}
        <path d={ROUTE} fill="none" stroke="rgba(240,168,41,0.15)" strokeWidth="7" strokeLinecap="round" />
        <path d={ROUTE} fill="none" stroke="#F0A829" strokeWidth="3" strokeLinecap="round" className="route-path" />
        <path id="kilted-route" d={ROUTE} fill="none" stroke="none" />
        <text fill="#B9C4B4" fontSize="10" fontFamily="JetBrains Mono, monospace" letterSpacing="3" opacity="0.75">
          <textPath href="#kilted-route" startOffset="16%">MONARO HWY</textPath>
        </text>
        <text fill="#B9C4B4" fontSize="10" fontFamily="JetBrains Mono, monospace" letterSpacing="3" opacity="0.75">
          <textPath href="#kilted-route" startOffset="80%">KOSCIUSZKO RD</textPath>
        </text>

        {/* moving courier marker */}
        <g>
          <circle r="10" fill="#0C1F17" stroke="#F0A829" strokeWidth="2" />
          <circle r="4" fill="#C8102E" />
          <animateMotion dur="14s" repeatCount="indefinite" path={ROUTE} rotate="auto" />
        </g>

        {/* main stops */}
        {STOPS.map((s) => {
          const lx = s.side === "end" ? s.x - 16 : s.x + 16;
          const cw = CHIP_W[s.chip];
          const chipX = s.side === "end" ? lx - cw : lx;
          const textX = s.side === "end" ? lx - 8 : lx + 8;
          return (
            <g key={s.town} data-testid={`route-stop-${s.town.toLowerCase().replace(/\s+/g, "-")}`}>
              <circle cx={s.x} cy={s.y} r="9" fill="none" stroke="#F0A829" strokeWidth="1.5">
                <animate attributeName="r" values="9;20" dur="2.2s" repeatCount="indefinite" />
                <animate attributeName="opacity" values="0.8;0" dur="2.2s" repeatCount="indefinite" />
              </circle>
              <circle cx={s.x} cy={s.y} r="6.5" fill={s.hub ? "#C8102E" : "#F0A829"} stroke="#0C1F17" strokeWidth="2" />
              <text
                x={lx}
                y={s.y - 4}
                textAnchor={s.side}
                fill="#F6F1E3"
                fontSize="20"
                fontWeight="700"
                fontFamily="Barlow Condensed, sans-serif"
                letterSpacing="1"
              >
                {s.town.toUpperCase()}
              </text>
              <rect x={chipX} y={s.y + 6} width={cw} height="18" rx="9" fill="#0C1F17" stroke="#1E9E5A" strokeOpacity="0.6" />
              <text
                x={textX}
                y={s.y + 19}
                textAnchor={s.side}
                fill="#1E9E5A"
                fontSize="9"
                fontFamily="JetBrains Mono, monospace"
                letterSpacing="1.5"
              >
                {s.chip.toUpperCase()}
              </text>
            </g>
          );
        })}

        {/* satellite towns */}
        {SATELLITES.map((s) => {
          const lx = s.side === "end" ? s.x - 10 : s.x + 10;
          return (
            <g key={s.town} data-testid={`route-stop-${s.town.toLowerCase().replace(/\s+/g, "-")}`}>
              <circle cx={s.x} cy={s.y} r="4" fill="#1E9E5A" stroke="#0C1F17" strokeWidth="1.5" />
              <text
                x={lx}
                y={s.y + 3.5}
                textAnchor={s.side}
                fill="#B9C4B4"
                fontSize="9.5"
                fontFamily="JetBrains Mono, monospace"
                letterSpacing="1.5"
              >
                {s.town.toUpperCase()}
              </text>
            </g>
          );
        })}
      </svg>
    </div>
  );
}
